import {
  IContact,
  IContactDetails,
  IContactDetailsRequestPayload,
  IContactListRequestPayload,
  IContactSaveRequestPayload,
} from 'contacts/types';
import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getContacts = async (
  requestPayload: IContactListRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/contacts/index/contacts?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IContact>(data.data, data?.recordsFiltered);
};

export const getContactDetails = async (
  requestPayload: IContactDetailsRequestPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<IContactDetails>> => {
  const { data } = await partfinitiClient.get(
    `/contacts/details?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  const contactDetails = { ...data };

  delete contactDetails['success'];

  return mapRecordFromServer<IContactDetails>(contactDetails, data.success);
};

export const saveContact = async (data: IContactSaveRequestPayload) =>
  partfinitiClient.postForm('/contacts/contact/save', data, { includeNullValues: true });

export const sendInvitation = async (contactId: number) =>
  partfinitiClient.postForm('/contacts/contact/invite-visitor', {
    contactId,
  });

export const revokeInvitation = async (contactId: number) =>
  partfinitiClient.postForm('/contacts/contact/revoke-visitor', {
    contactId,
  });

export const removeContacts = async (contactIds: number[]) => {
  return partfinitiClient.postForm('/contacts/contact/delete', { ids: contactIds });
};

export const restoreContacts = async (contactIds: number[]) => {
  return partfinitiClient.postForm('/contacts/contact/restore', { ids: contactIds });
};

export const updateContactOwner = async (
  corporateUserId: number,
  contactIds: number[],
  contactGroupIds?: number[]
) => {
  return partfinitiClient.postForm('/contacts/contact/update-owner', {
    corporateUserId: corporateUserId.toString(),
    contacts: contactIds,
    contactGroups: contactGroupIds,
  });
};

export const upsertContacts = async (
  contacts: Array<{ id: number; contactGroupingId: number }>
) => {
  return partfinitiClient.postForm('/contacts/contact/save-bulk', { contacts });
};
